import { useWizard } from "react-use-wizard";
import {
  TBooleanKeysOfIFillDataWizardBuy,
  TKeyOfDataWizardBuy,
} from "../../..";
import buySteps from "../../buySteps";
import FinanceStep from "../../../../../../../shared/wizard/steps/financeStep";

interface ISelectionByOwnSwapStep_9 {
  onChange: (data: boolean, key: TBooleanKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  data: boolean | null;
  isNextStepDisabled: boolean;
  triplePrevStep: boolean;
}

const SelectionByOwnSwapStep_9 = ({
  isNextStepDisabled,
  data,
  triplePrevStep,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_9) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(
      triplePrevStep
        ? buySteps.selectionSteps.swap.step_6
        : buySteps.selectionSteps.swap.step_8
    );
    onReset(["finance"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_10);
  };

  return (
    <div>
      <FinanceStep
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onChange={onChange}
        data={data}
        isNextStepDisabled={isNextStepDisabled}
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_9;
